import React from 'react'
import About_firstpage from './about-componenets/About_firstpage'
import About_text from './about-componenets/About_text'
import Carousal from './carousal/Carousal'
import Collaborate from './Homepage-components/Collaborate'

export default function Aboutus() {
  return (
    <>
      <About_firstpage/>
      <About_text/>
      <Carousal/>
      <Collaborate/>
    </>
  )
}
